import PropTypes from 'prop-types';
import style from '../ModalBoxWrapper.module.less';

function ModalBox(props) {
	const classes = [];
	if (props.withPaddingTop) {
		classes.push(style.modalContainerPaddingTop);
	}
	if (props.withPaddingBottom) {
		classes.push(style.modalContainerPaddingBottom);
	}
	if (props.variableHeight) {
		classes.push(style.modalContainerVariableHeight);
	}

	if (props.fixedWidth) {
		classes.push(style.modalContainerFixedWidth);
	}

	return (
		<div className={style.modalBackground}>
			<div className={style.modalContainer + ' ' + classes.join(' ')} style={props.maxWidth ? { maxWidth: props.maxWidth } : {}}>
				{props.children}
			</div>
		</div>
	);
}

ModalBox.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string,
	onClose: PropTypes.func,
	variableHeight: PropTypes.bool,
	withPaddingTop: PropTypes.bool,
	withPaddingBottom: PropTypes.bool,
	fixedWidth: PropTypes.bool,
	maxWidth: PropTypes.number,
};
ModalBox.defaultProps = {
	children: null,
	title: '',
	variableHeight: false,
	onClose: () => {},
	withPaddingTop: false,
	withPaddingBottom: false,
	fixedWidth: false,
	maxWidth: null,
};

export default ModalBox;
